import { formatPrice, dateToString } from "../utils/Utils";


class BillboardListConfirmItemReplaceClass{
    constructor(){
        this.main = document.getElementById('billboard_list_confirm_item_replace');

        this._cancelBtn = this.main.querySelector('.cancel_btn');
        this._acceptBtn = this.main.querySelector('.accept_btn');

        this._name = this.main.querySelector('.name');


        this._resolveFunction = null;
        
        this._cancelBtn.addEventListener('click', this._onClickCancelBtn.bind(this));
        this._acceptBtn.addEventListener('click', this._onClickAcceptBtn.bind(this));
    }

    show(newItemData, oldItemData){
        
        this.main.querySelector('.name').innerHTML = newItemData.name;

        this.main.querySelector('.old_date_range').innerHTML = `${dateToString(oldItemData.dateRange.from, 'M d')} to ${dateToString(oldItemData.dateRange.to, 'M d')}`;
        this.main.querySelector('.old_days_available').innerHTML = `${oldItemData.days_available} days`;
        this.main.querySelector('.old_price').innerHTML = `Price ${formatPrice(oldItemData.price)}`;

        this.main.querySelector('.new_date_range').innerHTML = `${dateToString(newItemData.dateRange.from, 'M d')} to ${dateToString(newItemData.dateRange.to, 'M d')}`;
        this.main.querySelector('.new_days_available').innerHTML = `${newItemData.days_available} days`;
        this.main.querySelector('.new_price').innerHTML = `Price ${formatPrice(newItemData.price)}`;
        
        document.body.classList.add('block-scroll');
        this.main.classList.add('modal--show');
        
        setTimeout(()=>{
            this.main.classList.add('modal--anim');
        }, 100);
        
        return new Promise((resolve, reject) => {
            this._resolveFunction = resolve;
        });
    }

    async _hide(){
        this.main.classList.remove('modal--anim');

        return new Promise((resolve, reject) => setTimeout(() => {
            this.main.classList.remove('modal--show');
            document.body.classList.remove('block-scroll');
            resolve();
        }, 750));
    }

    async _onClickCancelBtn(e){
        e.preventDefault();

        await this._hide();
        
        this._resolveFunction(false);
        
    }

    async _onClickAcceptBtn(e){
        e.preventDefault();
        
        await this._hide();
        
        this._resolveFunction(true);
        
    }

}

const BillboardListConfirmItemReplace = new BillboardListConfirmItemReplaceClass();
Object.seal(BillboardListConfirmItemReplace);

export default BillboardListConfirmItemReplace;
